
import React, { Component } from 'react';

// Utils
import { getMomentTZDateTime } from 'ts-util';

import TranslateManager from 'ts-translate-js';
import { EventDateInfo } from '../../../mvcapi/models/common';
const tr = TranslateManager.boundTR;

/* product: {
        ProductType: "Ticket" | "PrepaidCard" | "MembershipCard" | "Product" | "Donation";
        ProductNameFr?: string;
        ProductNameEn?: string;
        Date?: string;
        ProductInfo?: ProductInfo;
        ImportantInfo?: string;
        DateToBeDeterminated?: boolean;
        EventHasNoSpecificDate?: boolean; // WAS MISSING
        VenueName?: string; // WAS MISSING
        TimeZone?: { // WAS MISSING
            TZDatabaseID: string;
        };
        ProductName: string; // WAS MISSING
    }; */
  
interface ProductOverviewProps {
    product: EventDateInfo;
    onModifyThisStep?: () => void;
    onMembershipPresaleClick?: (membershipTypeID: number, isInMembershipCardPreSaleAndHaveValidCard: boolean) => void;
    onContentChange?: () => void; // Important for the resize of the iframe
    shouldDisplayChangeButton?: boolean;

}

export class ProductOverview extends Component<ProductOverviewProps> {
    static readonly defaultProps: Partial<ProductOverviewProps> = {
        shouldDisplayChangeButton: true
    };

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.raiseContentChanged();
    }

    componentDidUpdate () {
        this.raiseContentChanged();
    }

    raiseContentChanged() {
        // Set timeout because even though React rendered the tags, they are not yet drawn on the screen.
        setTimeout(function(){
            if(this.props.onContentChange !== undefined) this.props.onContentChange();
        }.bind(this), 0);
    }

    render() {
        let prodName;
        if(this.props.product.ProductType === "Ticket") {
            if(this.props.product.EventHasNoSpecificDate)
                prodName = this.props.product.ProductName; // TODO : traduire ceci avec cle de langue javascript
            else if (this.props.product.DateToBeDeterminated)
                prodName = tsapp.tr("Date à déterminer");
            else
                prodName = getMomentTZDateTime(this.props.product.Date, this.props.product.TimeZone.TZDatabaseID).format(tsapp.tr("program.format.moment.datetime"));
        }
        else if(this.props.product.ProductType === "PrepaidCard")
            prodName = this.props.product.ProductInfo.nameFr; // TODO : traduire ceci avec cle de langue javascript
        else
            prodName = this.props.product.ProductName; // TODO : traduire ceci avec cle de langue javascript

        let titleCtl = (this.props.product.ProductType === "Ticket" && !this.props.product.EventHasNoSpecificDate)
                        ? <h3>{tsapp.tr("program.eventdateinfo.yourdate")}</h3>
                        : null;

        //var item = this.getDateComboItem(this.state.eventDateInfoSelected);
        let prodNameCtl = (this.props.product.ProductType === "Ticket" && !this.props.product.EventHasNoSpecificDate)
                        ? prodName
                        : <h3>{prodName}</h3>;

        let modifStepButton = null;

        if(this.props.onModifyThisStep && this.props.shouldDisplayChangeButton)
            modifStepButton = (
                <li>
                    <button className="btn btn-default btn-xs" type="button" onClick={this.props.onModifyThisStep}>{tr("Changer")}</button>
                </li>
            );

        return (<div>
            <div className="row">
                <div className="col-xs-12 col-sm-8 col-sm-offset-2 text-center">
                    {titleCtl}

                    <ul className="list-inline">
                        <li>
                            {prodNameCtl}
                        </li>
                        {modifStepButton}
                    </ul>
                </div>
                
            </div>
            {this.props.product.VenueName ?
                <div className="row">
                    <div className="col-xs-12 col-sm-8 col-sm-offset-2 text-center">
                        <p className="venuename accented-text"><i className="fas fa-map-marker-alt"></i>&nbsp;{this.props.product.VenueName}</p>
                    </div>
                </div>
            : null}
            </div>
        );
    }
}